import { observer } from 'mobx-react';
import * as React from 'react';
import { DragDropContext, Draggable, Droppable, DroppableProvided } from '@hello-pangea/dnd';
import { emptyFragment } from '../../../../../../EmptyFragment';
import LearningCollectionEditStore from '../../../Edit/Store';
import {
  AddingLearningDesign,
  browseAllFieldValue,
  Building,
  EditFormSubmissionError,
  LearningCollectionEditFormResource,
} from '../../../Edit/Store/Types';
import BrowseAllExperiences from './BrowseAllExperiences';

interface Props {
  store: LearningCollectionEditStore;
  state: Building | EditFormSubmissionError | AddingLearningDesign;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

const LearningDesignBrowseAllExperiences: React.FC<Props> = ({
  store,
  state,
  learningCollectionEditFormResource,
}) => {
  return state.sections
    .filter((section) => browseAllFieldValue(section.template))
    .map((section, index) => (
      <DragDropContext onDragEnd={store.handleOnDragEndSections}>
        <Droppable droppableId="characters">
          {(provided: DroppableProvided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              <Draggable
                index={index}
                key={section.resource.payload.id}
                draggableId={String(section.resource.payload.id)}
              >
                {(provided) => {
                  switch (section.kind) {
                    case 'learning-design-section':
                      return (
                        <BrowseAllExperiences
                          store={store}
                          section={section}
                          provided={provided}
                          learningCollectionEditFormResource={learningCollectionEditFormResource}
                        />
                      );
                    case 'product-collection-section':
                      return emptyFragment();
                  }
                }}
              </Draggable>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    ));
};

export default observer(LearningDesignBrowseAllExperiences);
